import modular from 'stereomodularjs';
import * as modules from './modules';
import globals from './globals';
import { html } from './utils/environment';
import './utils/events';

const env = process.env.NODE_ENV

const app = new modular({
    modules: modules
});

window.onload = (event) => {
    const $style = document.getElementById('main-css');
    // classAdd(document.querySelector('body'), 't-' + document.querySelector('.js-scroll').getAttribute('data-namespace'))

    init();

    let isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    window.isMobile = isMobile;

    if (window.isMobile) {
        html.classList.add('is-mobile');
    }
};

function init() {
    globals();

    app.init(app);


    (function () {
        const ua = navigator.userAgent;

        // Uncomment line to test old safari
        //document.documentElement.classList.add("safari-older");

        // Vérifie si le navigateur est Safari (mais pas Chrome ou autre basé sur WebKit)
        const isSafari = /^((?!chrome|android).)*safari/i.test(ua);

        if (isSafari) {
            // Extrait la version de Safari
            const match = ua.match(/Version\/(\d+)\.(\d+)/);
            if (match) {
                const majorVersion = parseInt(match[1], 10);
                const minorVersion = parseInt(match[2], 10);

                // Vérifie si la version est inférieure à 14.1
                if (majorVersion < 14 || (majorVersion === 14 && minorVersion < 1)) {
                    console.log("Safari < 14.1 détecté !");
                    // Ajoute une classe au body ou applique un style spécifique
                    document.documentElement.classList.add("safari-older");
                }
            }
        }
    })();

    const loaderAnimation = new Promise(resolve => {
        const duration = 'development' ? 0 : 950
        let delay = new Date()
        delay = (delay - window.timestamp)
        delay = Math.max(0, duration - delay)
        setTimeout(() => {
            resolve()
        }, delay)
    })

    setTimeout(() => {
        let preventChilds = document.querySelectorAll('.js-prevent-childs a');
        preventChilds.forEach(el => {
            el.classList.add('js-prevent');
        });

         // Detect links with the class .cmplz-link.cookie-statement and add data-load="false"
        let cookieStatementLinks = document.querySelectorAll('.cmplz-link.cookie-statement');
        cookieStatementLinks.forEach(link => {
            link.setAttribute('data-load', 'false');
        });
    }, 10);

    Promise.all([loaderAnimation],).then(() => {
        setTimeout(() => {
            firtsLoadClasses();
        }, 800);
    })
}

function firtsLoadClasses() {
    setTimeout(() => {
        html.classList.add('is-first-loaded');
        html.classList.add('is-loaded');
        html.classList.add('dom-is-loaded');
        html.classList.remove('is-loading');

        setTimeout(() => {
            html.classList.add('anims-ready');
        }, 600);

    }, 1800);
}
